import * as React from "react";
import { useCoreFacade } from "../../../core/facades/Core.facade";
import PrwcAvatar from "../../../ui/widgets/custom/PrwcAvatar";
import PrwcAvatarGroup from "../../../ui/widgets/custom/PrwcAvatarGroup";

const ProfileTeamMembers = (props: any) => {
  const { data, limit = 10 } = props;
  const coreFacade = useCoreFacade();

  return (
    <div>
      {
        <PrwcAvatarGroup>
          {data &&
            data.map((member: any, index: number) =>
              index < limit ? (
                member.profileImage ? (
                  <PrwcAvatar
                    key={index}
                    image={member.profileImage}
                  ></PrwcAvatar>
                ) : (
                  <PrwcAvatar
                    key={index}
                    label={coreFacade.getInitialsOfFullName(
                      member.user.firstName,
                      member.user.lastName
                    )}
                    className="font-semibold"
                  ></PrwcAvatar>
                )
              ) : null
            )}
          {data && data.length > limit && (
            <PrwcAvatar label={"+" + (data.length - limit)} className="font-semibold text-white bg-blue-700"></PrwcAvatar>
          )}
        </PrwcAvatarGroup>
      }
    </div>
  );
};

export default ProfileTeamMembers;
